<template>
  <form class="account__form-wrap">
    <YourInformation />
    <YourEmail />
    <YourPassword />
    <AccountStatus />
  </form>
</template>

<script>
import YourInformation from "./overview/YourInformation";
import YourEmail from "./overview/YourEmail";
import YourPassword from "./overview/YourPassword";
import AccountStatus from "./overview/AccountStatus";
import { mapActions } from "vuex";

export default {
  name: "AccountOverview",
  components: {
    YourInformation,
    YourEmail,
    YourPassword,
    AccountStatus,
  },
};
</script>

<style></style>
